// extracted by mini-css-extract-plugin
module.exports = {"verify-container":"Verify_verify-container__Kgqh-","box":"Verify_box__3kOCd","action":"Verify_action__2c7HI"};